export const CurrencyByCountryCode: Record<string, string> = {
  MD: 'MDL',
  RO: 'RON',
  KZ: 'KZT',
  US: 'USD',
  PL: 'PLN',
};
